import * as React from 'react'
import { Grid, Input, Select, MenuItem, RadioGroup, FormControlLabel, Radio, Checkbox } from '@material-ui/core';

export default class PullFromRepositoryPreviewComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            question: {},
            classTypes: [1, 2, 3]
        }
    }

    componentDidMount() {
        if (this.props.question) {
            this.setState({ question: this.props.question });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps.question) {
            this.setState({ question: nextProps.question });
        }
    }

    renderControl = (classTypeIndex: any) => {
        switch (this.state.question.input_type) {
            case 1:
                return <Input />
            case 2:
                return <Input type="number" />
            case 3:
                return <Input type="date" />
            case 4:
                return (
                    <Select fullWidth={true} >
                        {
                            this.state.question.items && this.state.question.items.length > 0 && this.state.question.items.map((item: any, menuIndex: number) => {
                                return (
                                    menuIndex === classTypeIndex && item.choices.map((choice: any, choiceIndex: any) => {
                                        return (
                                            <MenuItem value={choice.value}
                                                key={'key_' + choiceIndex}
                                            >
                                                {choice.text.en ? choice.text.en : ''}
                                            </MenuItem>
                                        )
                                    })
                                )
                            })
                        }
                    </Select>
                )
            case 5:
                return (
                    <>

                        <RadioGroup className="radioGroup"
                            aria-label="position"
                            row={true}
                        >
                            {
                                this.state.question.items && this.state.question.items.length > 0 && this.state.question.items.map((item: any, rdoIndex: number) => {
                                    return (
                                        rdoIndex === classTypeIndex && item.choices.map((choice: any, key: any) => {
                                            return <FormControlLabel key={"radio_" + key}
                                                control={<Radio color="primary" checked={false} />}
                                                label={choice.text.en ? choice.text.en : ''}
                                                labelPlacement="end"
                                            />
                                        })
                                    )
                                })
                            }
                        </RadioGroup>
                    </>
                )
            case 6:
                return (
                    this.state.question.items && this.state.question.items.length > 0 && this.state.question.items.map((item: any, chkIndex: number) => {
                        return (
                            chkIndex === classTypeIndex && item.choices.map((choice: any, key: any) => {
                                return <FormControlLabel key={"check_" + key}
                                    control={
                                        <Checkbox
                                            key={key}
                                            color="primary"
                                            checked={false}
                                        />
                                    }
                                    label={choice.text.en ? choice.text.en : ''}
                                />
                            })
                        )
                    })
                )
        }

        return null;
    }

    render() {
        return (
            <>
                <Grid container={true} spacing={24}>
                    <Grid item={true} xs={12}>
                        <b>{this.state.question.title ? this.state.question.title.en : ''}</b>
                    </Grid>
                </Grid>
                <Grid container={true} spacing={24}>
                    {
                        this.state.classTypes.filter((ct: any) => ct <= this.state.question.class_type).map((ct: any, index: any) => {
                            return (
                                <Grid key={"class_type_" + ct} item={true} xs={12}>
                                    <>
                                        <div>
                                            {
                                                (index + 1) === 1 ?
                                                    (this.props.question.question_one_title ? this.props.question.question_one_title.en : '') :
                                                    (index + 1) === 2 ?
                                                        (this.props.question.question_two_title ? this.props.question.question_two_title.en : '')
                                                        :
                                                        (this.props.question.question_three_title ? this.props.question.question_three_title.en : '')
                                            }
                                        </div>
                                        {
                                            this.renderControl(index)
                                        }
                                    </>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/PullFromRepositoryPreviewComponent.tsx